import React, { useContext, useEffect, useRef, useState } from "react";
import EditInformationModal from "./EditInformationModal";
import ProductsOffcanvas from "./ProductsOffcanvas";
import CardDiv from "modules/common/card-div/CardDiv";
import SoftBadge from "modules/common/SoftBadge";
import SelectAndInput from "modules/nextcall/SelectAndInput";
import CopyComponent from "./CopyComponent";
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useCall, useChatSlotData, useCustomer, useGetAllTag, useLeadAssignOrder } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CallIcon from "assets/svgs/table_call";
import CallCut from "assets/svgs/call_cut.js";
import { UserStatus } from "./UserStatus";
import PrescriptionOrder from "./PrescriptionOrder";
import { useBookingData, useNextEngagement, useOralMinox } from "modules/nextcall/store";
import AppUser from "assets/svgs/app_user";
import { Tooltip } from "antd";
import NotAppUser from "assets/svgs/not_app_user";
import { LinkOutlined } from "@ant-design/icons";
import MultiSelect from "modules/nextcall/MultiSelect";
import {Button,Col, Modal,Row} from "react-bootstrap";
import {adminRole,allowedLevels, externalMedrep,externalUsers,getCurrentUserRole, statusTagColor,THIRD_PARTY_MEDREPS,voitekkAcess, TOAST_MESSAGE_CSS,currentUser, getJsonFromSecureLocalStorage, getCustomerPhoneNumberByPhoneType, CALL_PROVIDERS, ROLES_NAME, SMART_ASSIST_ACCESS, IS_DOCTOR} from "modules/utilities/utility";
import { voitekkUserIdMap } from "modules/utilities/voitekkUSerIdMap";
import AllOrderAssign from "modules/order_management/AllOrderAssign";
import { useAllOrderStore } from "modules/order_management/store";
import VoitekkIntegration from "./VoitekkIntegration";
import BackIcon from "assets/svgs/backIcon";
import ConsultDoctorCanvas from "./ConsultDoctorCanvas";
import RewardsPoints from "pages/RewardsPoints";
import Userlog from "modules/user_log/Userlog"
import TaskList from "pages/TaskList";
import { toast } from "react-toastify";
import { CustomerProps } from "./ShowCustomer";
import MobileTaskList from "pages/MobileTaskList";
import OrderDetails from "modules/order_details/OrderDetails";
import CreateTicketScreen from "modules/CreateTicket/CreateTicketScreen";
import Chats from "modules/Chats";
import DietPlanCanvas from "modules/diet_plan/DietPlanCanvas";
import ClinicAssignment from "./ClinicAssignment";
import { DIRECT_LOGIN_EMAIL } from "modules/utilities/utility_2";
import secureLocalStorage from "react-secure-storage";
import { getCallProviderComponent } from "./service";
import { useOrderDetailsStore } from "modules/order_details/store";
import { useMobileHomeTaskList } from "pages/store";
import { get } from "lodash";
import { useCallingStore } from 'modules/navbar/top/store/store';
import { ActiveEngagement } from "./ShowEngagement";
import SmartAssist from "./smart-assist/SmartAssist";
import PostPurchaseFeedback from "./postPurchaseFeedback";

function EngagementHeader() {
  const {voitekkCalling, exotelCalling, updateCallingStatus } = useCallingStore();
  const { nextEngagementData } = useNextEngagement();
  const { customerData, arrowHide, customer, caseId, customerOrder } = useContext(CustomerProps);
  const { id } = useParams();
  const currentUrl = window.location.href.split("/");
  const route = window.location.pathname.split('/')[1]
  const repLevel = secureLocalStorage.getItem("level");
  const { setToaster } = useToast();
  const { call } = useCall();
  const [callIcon, setCallIcon] = useState(exotelCalling ? <CallCut/> : <CallIcon />);
  const prevCustomerIdRef = useRef(null);
  const [showCopiedModal, setShowCopiedModal] = useState(false);
  const { allTag, fetchTagData } = useGetAllTag();
  const [options, setOptions] = useState([]);
  const [assign, setAssign] = useState(null);
  const [sortedCustomerData, setSortedCustomerData] = useState();
  const [callDndFlag, setCallDndFlag] = useState(false);
  const [whatsAppDndFlag, setWhatsAppDndFlag] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const doctor = ["clinic_doctor"];
  const utm_name = secureLocalStorage.getItem("clinic_emp_id");
  const navigate = useNavigate();
  const { medicalData, consultData, operationData, fetchMedicalRep, fetchConsultRep, fetchOperations, } = useAllOrderStore();
  const {fetchNearestSlot} = useChatSlotData();

  const { isLoading, postLeadAssignOrder } = useLeadAssignOrder();
  const { fetchCustomerData } = useCustomer();
  const { oralMinoxData, fetchOralMinox } = useOralMinox();
  const { orderData, fetchOrderData } = useOrderDetailsStore();
  const { segmentData, fetchAllSegmentData } = useMobileHomeTaskList();
  const [params] = useSearchParams();
  const offline = params.get("offline");
  
  const { engagementData } = useContext(ActiveEngagement);
  const engagementId = engagementData ? engagementData._id : null;
  const voitekUser = secureLocalStorage.getItem('voitekk_id');
  const voitekUserData = (voitekUser!==null && voitekUser!=="null")? voitekUser :false;
  const callProvider = getJsonFromSecureLocalStorage("call_providers");
  const nextCallProvider =
    Array.isArray(callProvider) &&
    _.find(callProvider, (provider) => {
      const nextCallValue = _.get(provider, "next_call");
      return [true, "true"].includes(nextCallValue);
    });

  const nextCallProviderName = _.get(nextCallProvider, "provider_name", null);

  useEffect(() => {
    if (caseId) {
      // fetchOralMinox(caseId);
      // const caseData = get(segmentData, "case.id", null);
      // caseData !== caseId && fetchAllSegmentData(caseId);
      // fetchOrderData(caseId);
    }
  }, [customer]);

  useEffect(() => {
    fetchTagData();
    if (adminRole.includes(getCurrentUserRole()) && modalShow) {
      fetchMedicalRep();
      fetchConsultRep();
      fetchOperations();
    }
  }, [modalShow]);
  useEffect(() => {
    // Make a copy of the orders array to avoid mutating the original data
    const sortedOrders = Array.from(customerOrder || []).sort(
      (orderA, orderB) => {
        return new Date(orderA?.created_at) - new Date(orderB?.created_at);
      }
    );
    setSortedCustomerData(sortedOrders);
  }, [customer]);

  useEffect(() => {
    if (id && nextEngagementData && currentUrl.includes("next-call")) {
      setCallIcon(exotelCalling ? <CallCut /> : <CallIcon />);
      if (nextEngagementData.case_id !== secureLocalStorage.getItem("previousCustomer") && nextEngagementData.case_id === id) {
       const phoneNumber = getCustomerPhoneNumberByPhoneType(customerData,"phone");
       //Condition for voitekk for pre-sales,which is handelled in voitekkIntegration component
       if(voitekUserData && [ROLES_NAME.LEAD_AGENT].includes(currentUser)){
        return;
       }
       call(id, {}, nextEngagementData?._id, phoneNumber, setToaster, false, nextCallProviderName).then(
         (response) => {
           if (response) {
             const providerName = _.get(response,["result", "provider_name"],null);
             if (providerName === CALL_PROVIDERS.KNOWLARITY_V1) {
               //Send this event for open the iframe modal
               KNW_WIDGET?.sendMessage("c2c_call");
             }
           }
         }
       );
        prevCustomerIdRef.current = id;
        secureLocalStorage.setItem("previousCustomer", prevCustomerIdRef.current);
      }
    } else { setCallIcon(exotelCalling ? <CallCut /> : <CallIcon />);}
  }, [id]);

  useEffect(() => {
    const tag = allTag.map((selectedTag) => {
      return {
        value: selectedTag?.slug,
        label: selectedTag?.display_name,
        id: selectedTag?.id,
      };
    });
    setOptions(tag);
  }, [allTag]);

  useEffect(() => {
    const callData = customer?.caseTags?.find(
      ({ tag }) => tag?.display_name === "Call DND"
    );
    const whatsData = customer?.caseTags?.find(
      ({ tag }) => tag?.display_name === "Whatsapp DND"
    );

    if(engagementData?.tag === "SLOT_BOOKING" || engagementData?.is_slot_booked){
      setCallDndFlag(false);
    } else {
      setCallDndFlag(!!callData);
      setWhatsAppDndFlag(!!whatsData);
    }
  }, [id, engagementData]);

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setShowCopiedModal(true);
        setTimeout(() => {
          setShowCopiedModal(false);
        }, 500);
      })
      .catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
      });
  };

  const handleAssign = () => {
    const order_id = null;
    postLeadAssignOrder(
      {
        case_id: id,
        user_id: assign,
        order_id: order_id,
      },
      setToaster,
      fetchCustomerData,
      id
    );
  };

  const renderConsultDoctorCanvas = (buttonLabel) => (
    <ConsultDoctorCanvas
      caseId={customer?.id}
      name={customer?.user?.first_name}
      email={customer?.user?.email}
      phone={customer?.user?.phone_number}
      slotBooking={true}
      button={buttonLabel}
    />
  );

  const medRepName = secureLocalStorage.getItem("first_name").replace(" ", "_");

  const handleBookCall= (caseId) => {
    fetchNearestSlot(caseId);
  }

  const adminAceess = ["super_admin", "admin"];
  const bahAccess = ["super_admin", "admin", "chat", "support"];
  const formLink =`https://formv2s.dev.hav-g.in/questions?utm_campaign=${utm_name}`
  const isPcAccess = [ROLES_NAME.LEAD_AGENT, ROLES_NAME.CHAT, ROLES_NAME.IVR, ROLES_NAME.MEDICAL_REP, ROLES_NAME.CLINIC_RECEPTIONIST].includes(currentUser);

  return (
    <div
      style={{top: arrowHide?"5.15rem":"1rem",position: "sticky",zIndex: "99"}}
      className="d-flex flex-column justify-content-between bg-white border-primary mx-3 mb-3 ms-0 mt-1 rounded"
    >
      <CardDiv
        component={
          <>
            <div className="w-100 d-flex justify-content-between ps-3">
              <div className="flex-1">
                <Row style={{ width: "100%", position: "sticky", top: "0" }} className="d-flex flex-wrap gap-2">
                  <Col className="pe-0 text-black" style={{ flex: 3.8, cursor: !arrowHide && "pointer" }}>
                    <div className="d-flex flex-column">
                      <h4 className="text-primary text-capitalize d-flex gap-1">
                        <span className="d-flex align-items-center">
                          <span className="d-flex flex-row gap-2 align-items-center">
                            {currentUrl.includes("next-call") || currentUrl.includes("lead-details") ? (
                              <Tooltip title="Go to Back">
                                <span className="cursor-pointer me-3" onClick={() => navigate(-1)} type="link">
                                  <BackIcon />
                                </span>
                              </Tooltip>
                            ) : null}
                          </span>
                          {
                            <Tooltip title="Leads Details">
                              <span className="">
                                <Link to={route === 'next-call' ? '#': `/lead-details/${customer?.id}`}>
                                  {customer?.user?.first_name}
                                </Link>
                              </span>
                            </Tooltip>
                          }
                        </span>
                        <div className="d-flex ">
                          <Tooltip title={customer?.app_user? "App User": "Not an app user"}>
                            <span>{customer?.app_user ? (<AppUser />) : (<NotAppUser /> )}</span>
                          </Tooltip>
                          <span className="ms-1">
                            {allowedLevels.includes(repLevel) ? (<UserStatus engagements={customer} />) : (<SoftBadge bg={statusTagColor[customer?.status]}>{customer?.status?.toUpperCase()}</SoftBadge>)}
                          </span>
                          <Tooltip
                            title={
                              <div className="fw-bold">
                                <div className="border-bottom border-white">Dosage :{"  "}{oralMinoxData.dosage}</div>
                                <div className="border-bottom border-white">month :{"  "}{oralMinoxData.month}</div>
                                <div>Comment: {"  "}{oralMinoxData.comment}</div>
                              </div>
                            }
                          >
                            <span className="ms-2 px-1 shadow-sm text-danger">
                              {oralMinoxData.oralMinoxExistsInPrescrition ? (<span style={{ fontSize: "10px" }}>Oral Minox</span>) : null}
                            </span>
                          </Tooltip>
                        </div>
                        <span className="">
                          {customer?.user?.last_name}
                        </span>
                      </h4>
                      <div className="d-flex flex-row flex-wrap gap-1 w-100">
                        <div className="d-flx flex-column shadow-sm  p-2" style={{ width: "60%" }}>
                          <div className="fs-1 text-truncate" style={{ color: "#333333", fontSize: "1rem" }}>MedRep</div>
                          <div className="fw-bold text-black text-truncate">{customer?.assignment?.first_name}</div>
                        </div>
                        <div className="d-flx flex-column shadow-sm  p-2" style={{ width: "35%" }}>
                          <div className="fs-1 text-truncate" style={{ color: "#333333", fontSize: "1rem" }}>Gender</div>
                          <div className="fw-bold text-black">{customer?.user?.gender?.toUpperCase() === "F" ? "Female" : customer?.user?.gender?.toUpperCase() === "M" ? "Male": "N/A"}</div>
                        </div>
                      </div>
                      <div className="d-flex flex-row flex-wrap w-100 gap-1">
                        <div className="d-flx flex-column shadow-sm  p-2 mt-1" style={{ width: "60%" }}>
                          <div className="fs-1" style={{ color: "#333333", fontSize: "1rem" }}>Email</div>
                          <div className="fw-bold text-truncate text-black">{customer?.user?.email}</div>
                        </div>
                        <div className="d-flx flex-column shadow-sm  p-2 mt-1" style={{ width: "35%" }}>
                          <div className="text-truncate" style={{ color: "#333333", fontSize: "1rem" }}>Phone Number</div>
                          <div className="fw-bold text-black text-truncate">
                            {customer?.user?.phone_number}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  {currentUrl.includes("next-call") || currentUrl.includes("lead-details") ? (
                    <Col className="mb-0 d-flex align-items-end" style={{ flex: "0.6" }}>
                      <div className="d-flex align-items-end">
                        {!externalUsers.includes(getCurrentUserRole()) && (
                          <Row className="py-2 w-0">
                          {offline ? null: <div className="d-flex gap-2 justify-content-center">
                              <Col>
                                <Tooltip placement="bottom" title="Exoctel">
                                  <div className={`mb-2 text-center ${callDndFlag? "disabled-action ": "cursor-pointer"}`}>
                                    <span
                                      className={`text-center ${callDndFlag? "disabled-action ": "cursor-pointer"}`}
                                      onClick={ 
                                        callDndFlag
                                          ? () => {toast("Customer is in DND mode, Please do not call",TOAST_MESSAGE_CSS);}
                                          : () => {
                                              updateCallingStatus('exotelCalling', !exotelCalling);
                                              setCallIcon(<CallCut />);
                                              !currentUrl.includes("next-call")
                                                ? !exotelCalling && call(customerData.id, IS_DOCTOR.includes(currentUser) ? { isDoctor: true } : {}, engagementId, customerData?.user?.phone_number ||customerData?.orders[0]?.order_phone_number,setToaster)
                                                : null;
                                            }
                                      }
                                    >
                                      {callIcon}
                                    </span>
                                  </div>
                                </Tooltip>
                                {voitekkAcess.includes(getCurrentUserRole()) && (
                                  <VoitekkIntegration
                                    phone={customer?.user?.phone_number}
                                    name={secureLocalStorage.getItem("first_name").replace(" ", "").toLowerCase()}
                                    userId={voitekkUserIdMap[secureLocalStorage.getItem("id")]}
                                    caseId={caseId}
                                    callDndFlag={callDndFlag}
                                    nextEngagementData={nextEngagementData}
                                    nextCallProvider={nextCallProvider}
                                  />
                                )}
                                {!externalMedrep.includes(getCurrentUserRole()) && !doctor.includes(getCurrentUserRole()) && (<div className="mt-2"><EditInformationModal customer={customer}/></div>)}
                              </Col>
                              {Array.isArray(callProvider) && callProvider.length > 0 && (
                              <Col>
                                <div style={{ 
                                  display: "grid", 
                                  gridTemplateRows: "1fr 1fr", 
                                  gridTemplateColumns: `repeat(${Math.ceil(callProvider.length / 2)}, 1fr)`,
                                  gap: "0.5rem" 
                                }}>
                                  {callProvider.map((provider, index) => (
                                    <div 
                                      key={index} 
                                    >
                                      {getCallProviderComponent(provider, customerData, "phone", callDndFlag)}
                                    </div>
                                  ))}
                                </div>
                                </Col>
                                )}
                            </div>}
                          </Row>
                        )}
                      </div>
                    </Col>
                  ) : null}
                  {currentUrl.includes("next-call") || currentUrl.includes("lead-details") ? (
                    <Col style={{ flex: 3.7 }} className="d-flex flex-column justify-content-end gap-2 mt-3">
                      {/* <div className="d-flex flex-row ms-2 mb-n3 gap-1 ">
                        <p className="font-poppins text-nowrap fw-bold shadow px-2">
                          Running Month Kit :{" "}
                          <span className="value fw-bold text-black">
                            {get(segmentData, "runningMonthForHairKit", "0")}
                          </span>
                        </p>
                        <p className="font-poppins text-nowrap fw-bold shadow px-2">
                          Delivered Kit Count :{" "}
                          <span className="value text-black">
                            {get(orderData, "actualKitCountForUser", "0")}
                          </span>
                        </p>
                      </div> */}
                      <div className="d-flex gap-2">
                        <ProductsOffcanvas
                          case_id={customer.id}
                          customerName={customer?.user?.first_name +(customer?.user?.last_name || "")}
                          orderCount={customer.latest_order_count || 0}
                          user={customer.user}
                          address={sortedCustomerData && sortedCustomerData?.length > 0? sortedCustomerData[sortedCustomerData?.length - 1]?.order_meta?.shipping_address: []}
                          billingAddress={customer?.orders[customer.orders?.length - 1]?.order_meta?.billing_address}
                        />
                        <div><PrescriptionOrder customer={customer} /></div>
                        
                        <div>{isPcAccess || getCurrentUserRole() === ROLES_NAME.SUPPORT ?  renderConsultDoctorCanvas("Offline-Booking"):null}</div>
                        {adminRole.includes(getCurrentUserRole()) &&
                        (currentUrl.includes("next-call") || currentUrl.includes("lead-details")) ? (
                          <div>
                            <Button style={{ height: "2.6rem" }} onClick={() => setModalShow(true)} className="me-n1">Assign</Button>
                            <Modal
                              show={modalShow}
                              onHide={() => setModalShow(false)}
                              size="md"
                              aria-labelledby="contained-modal-title-vcenter"
                              style={{ height: "30rem" }}
                            >
                              <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter">Assign</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <>
                                  <div className="d-flex ms-3 justify-content-end pb-1">
                                    <div className="d-flex">
                                      <AllOrderAssign
                                        medicalReps={medicalData}
                                        consultReps={consultData}
                                        operationsReps={operationData}
                                        assign={assign}
                                        setAssign={setAssign}
                                      />
                                      <button className={assign? "btn btn-primary": "btn btn-primary disabled"} onClick={handleAssign}>
                                        {isLoading ? "assigning" : "Assign"}
                                      </button>
                                    </div>
                                  </div>
                                </>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button onClick={() => setModalShow(false)}>Close</Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex">
                        <div className="mt-n2">
                          <CreateTicketScreen customerData={customer} />
                        </div>
                        <div className="flex-1 d-flex flex-row gap-1">
                        {!isPcAccess ? (
                          renderConsultDoctorCanvas("Slot-Booking")
                        ) : (
                        <>
                          {renderConsultDoctorCanvas("Slot-Book")}
                          {renderConsultDoctorCanvas("Pres-Book")}
                        </>
                        )}
                        </div>
                        <div className="flex-1">
                          <Button
                            className="ms-1 w-100"
                            style={{ height: "2.5rem" }}
                            onClick={() => handleCopy(`form.traya.health/recommendedcart/${customer?.id}?utm_source=direct&utm_medium=hair_coach&utm_campaign=${medRepName}`)}
                          >
                            <span className="pe-1 text-truncate">Reorder Link{" "}<span className="ms-1">{<LinkOutlined />}</span></span>
                          </Button>
                          <Modal show={showCopiedModal} onHide={() => setShowCopiedModal(false)}>
                            <Modal.Body><span style={{ width: "5rem" }}>Feedback Form Link Copied!</span></Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </Col>
                  ) : null}
                  {offline ? null : currentUrl.includes("next-call") ||
                  currentUrl.includes("lead-details") ? (
                    <Col
                      style={{ padding: 0, flex: 4 }}
                      className="mb-2 d-flex flex-column justify-content-end"
                    >
                      <div className="d-flex justify-content-end">
                        <div className="d-flex gap-1 justify-content-center align-items-center">
                          {['chat'].includes(currentUser) && <Button className="mt-1" onClick={() => handleBookCall(customerData.id)}>
                            Book Chat Call
                          </Button>}  
                          {SMART_ASSIST_ACCESS.includes(secureLocalStorage.getItem('email')) && <SmartAssist />}
                          {ROLES_NAME.CLINIC_RECEPTIONIST === getCurrentUserRole() && <PostPurchaseFeedback />}

                          {currentUrl.includes("lead-details") && bahAccess.includes(currentUser) && <Userlog />}
                          {currentUrl.includes("lead-details") && bahAccess.includes(currentUser) && (<RewardsPoints />)}
                          {currentUser === "super_admin" ? ( <span className="mt-1">{currentUrl.includes("lead-details") && (<MobileTaskList />)}</span>) : null}
                          {currentUrl.includes("lead-details") && adminAceess.includes(currentUser) && <TaskList />}
                          {currentUrl.includes("lead-details") && adminAceess.includes(currentUser) && (<OrderDetails />)}
                          {currentUrl.includes("lead-details") && adminAceess.includes(currentUser) && (<DietPlanCanvas />)}
                          {currentUrl.includes("lead-details") &&
                            doctor.includes(currentUser) && (
                              <a href={formLink} target="_blank">
                                <button class="bg-primary border rounded-3 p-2 font-poppins text-white">
                                  Take Hair Test
                                </button>
                              </a>
                            )}
                        </div>
                      </div>
                      <div className="d-flex w-100 my-2">
                        <SelectAndInput customer={customer} whatsAppDndFlag={whatsAppDndFlag}/>
                      </div>
                      <MultiSelect options={options} customer={customer} placeholder="Select Tags"/>
                    </Col>
                  ) : (
                    <Col style={{ padding: 0, flex: 5 }} className="mb-2 d-flex flex-column justify-content-end">
                      <div className="d-flex ms-n2" style={{ height: "3rem" }}>
                        <ProductsOffcanvas
                          case_id={customer?.id}
                          customerName={customer?.user?.first_name + (customer?.user?.last_name || "")}
                          orderCount={customer?.latest_order_count || 0}
                          user={customer?.user}
                          address={ sortedCustomerData && sortedCustomerData?.length > 0? sortedCustomerData[sortedCustomerData?.length - 1]?.order_meta?.shipping_address: []}
                          billingAddress={customer?.orders[customer?.orders?.length - 1]?.order_meta?.billing_address}
                        />
                        <div className="mt-n2 me-2">
                          <CreateTicketScreen customer={customer} />
                        </div>
                        <div className="">
                          {renderConsultDoctorCanvas("Slot-Booking")}
                        </div>
                      </div>
                      <div className="d-flex w-100 my-2">
                        <SelectAndInput customer={customer} whatsAppDndFlag={whatsAppDndFlag}/>
                      </div>
                      <MultiSelect
                        style={{}}
                        options={options}
                        customer={customer}
                        placeholder="Select Tags"
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </>
        }
      />
    </div>
  );
}

export default EngagementHeader;
